import styled from "styled-components";
import { V3HeadlineH5 } from "../Typography";

export const PostPreviewImage = styled.div`
    width: 100%;
    padding-bottom: 51.07%;
    height: 0;
    background-size: cover;
    border-radius: 18px;
    position: relative;
`;

export const PPImage = styled.img`
    position: absolute;
    object-fit: cover;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 18px;
`;

export const PostPreviewTagBadge = styled(V3HeadlineH5)`
    color: ${({ theme }) => theme.v3.colors.blue};
`;